import { CardImage } from './card-image';
import { CardActions, CardContent, CardWrapper } from './styles';
import { CardProps } from './types';

export const Card = ({ children }: CardProps) => <CardWrapper>{children}</CardWrapper>;

Card.Image = CardImage;
Card.Content = CardContent;
Card.Actions = CardActions;
